import React, { useState, useEffect, useMemo } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import DetailsCostTile from '../estimates/detailsCostTile';
import DetailsDescriptionTile from '../estimates/detailsDescriptionTile';
import DetailsEstimateBreakdown from '../estimates/detailsEstimateBreakdown';
import DetailsInsuranceBreakdown from '../estimates/detailsInsuranceBreakdown';
import ErrorMessage from "../estimates/ErrorMessage";
//import downLoadEstimate from "../../api/pricingApi";
//import DownloadLink from "react-download-link";
import * as types from "../../constants/actionTypes";
import Spinner from '../common/spinner';
//import SectionLoading from '../common/SectionLoading';
import { logUI } from "../../api/andyliticsApi";


//withRouter(connect(mapStateToPropsdetailsCostTile.js mapDispatchToProps)(props => {
const EstimateDetails = props => {
    const { patient, currentUser } = props;
    const enablePricingSharebutton = window && window.serverData && window.serverData.data ? window.serverData.data.enablePricingSharebutton : false;
    const selfPay = props.benefitDetails.length > 0 ? props.benefitDetails[0].isSelfPay.toLowerCase() === "true" : false;
    const hasMultipleInsuranceApplied = props.benefitDetails.length > 0 ? props.benefitDetails[0].hasMultipleInsuranceApplied.toLowerCase() === "true" : false;
    const csnId = props.benefitDetails.length > 0 ? props.benefitDetails[0].csnId : '';
    const estimateSpinnerPage = <div className={"container-fluid body-content estimate-details-page"}><Spinner /></div>;
    /* eslint-disable react-hooks/exhaustive-deps */
    //Including props.history is not specific enough thus causes undesirable refreshes
    //useEffect(() => {
    //    if (props.accessDenied) props.history.push(props.redirect === "" ? "/estimates/myEstimates" : props.redirect);
    //}, [props.accessDenied, props.redirect]);
    /* eslint-enable react-hooks/exhaustive-deps*/

    try {
        return (props.enablePricingTransparency) ?
            (props.benefitDetails.length === 0) ? estimateSpinnerPage :
                displayErrorMessage(props.benefitDetails) ? <ErrorMessage customerServicePhone={props.customerServicePhone} /> :
                    <React.Fragment >
                        <div  id="estimateDetails-body" className={"container-fluid body-content estimate-details-page aal-lg-margin"}>
                            <div className="row">
                                <div className="col-12 maxWidth-content">
                                    <div className="row">
                                        <div className="col-xl-8 col-lg-6 col-8">
                                            <h1 className="page-heading">Estimate Details{patient.EID !== currentUser.eid ? <span> ({props.benefitDetails[0].patientInformation.firstName})</span> : <React.Fragment></React.Fragment>}</h1>
                                        </div>
                                        {enablePricingSharebutton && props.pdf && <div className="col-xl-4 col-lg-6 col-4 share-button-container">

                                            <a href={`${props.pdf ? window.URL.createObjectURL(props.pdf) : ''}`} download={`Estimate-${csnId}.pdf`}>
                                                <div className="btn float-right share-button"><span className="">SHARE</span></div>
                                            </a>
                                        </div>}
                                    </div>
                                    <DetailsCostTile hasMultipleInsuranceApplied={hasMultipleInsuranceApplied } pricingCOVIDMessage={props.pricingCOVIDMessage} isSelfPay={selfPay} key={`DetailsCostTile-${csnId}`} benefitDetails={props.benefitDetails}/>
                                    <DetailsDescriptionTile isSelfPay={selfPay} key={`DetailsDescriptionTile-${csnId}`} benefitDetails={props.benefitDetails} />
                                    <div className="row">
                                        <div className="col-xl-5 col-lg-6 col-12 estimate-breakdown-panel">
                                            <DetailsEstimateBreakdown isSelfPay={selfPay} key={`DetailsEstimateBreakdown-${props.msgId}`} benefitDetails={props.benefitDetails} />
                                        </div>
                                        <div className="col-xl-7 col-lg-6 col-12 insurance-breakdown-panel">
                                            {selfPay ? <></>
                                                : <DetailsInsuranceBreakdown isSelfPay={selfPay} key={`DetailsInsuranceBreakdown-${props.msgId}`} benefitDetails={props.benefitDetails}/>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className={`container-fluid footer-container estimate-footer`}>
                                <div className="row">
                                    <div className="col-12 maxWidth-content">
                                        Contact our Pre-Registration department Monday through Friday, 8:00AM to 5:00PM : <a className="phone-link" href={"tel:" + props.customerServicePhone}>{props.customerServicePhone}</a>
                                    </div>
                                </div>
                            </div> 
                        
                    </React.Fragment >
            : <React.Fragment>estimateSpinnerPage</React.Fragment >;

    } catch (ex) {
        console.error(`estimateDetails estimateDetails/${props.msgId}`,props,ex.message);
        logUI("MBHWeb.UI.Estimates.estimateDetails", new Date(), `estimateDetails/${props.msgId}`, props, 'ERROR', ex.message);
        return <ErrorMessage customerServicePhone={props.customerServicePhone} />;
    }
};


function mapStateToProps(state) {
    return {
        enablePricingTransparency: state.session.serverData.enablePricingTransparency,
        pricingCOVIDMessage: state.session.serverData.pricingCOVIDMessage,
        customerServicePhone: state.session.serverData.pricingPreRegPhone,
        redirect: state.pricing.redirect
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        logScrolledToBottom: (csnId,cu,pu) => { dispatch({ type: types.ESTIMATE_DETAILS_SCROLL_TO_BOTTOM, data: { csnIdOfAppointment: csnId, currentUser: cu, primaryUser: pu } }); },
    }
}

const displayErrorMessage = (benDet) => {
    console.error(`estimateDetails displayErrorMessage benDet length'${benDet.length}'`, benDet);
    if (benDet.length === 0) {
        return false;
    }
    const bd = benDet[0];
    //if (quote.surePayHealthDetail) {
    //    console.info(`estimateDetails displayErrorMessage has surePayHealth`);
    //    const surPay = quote.surePayHealthDetail;
        if (bd.patientFinancialResponsibilityDetail) {
            const pfrd = bd.patientFinancialResponsibilityDetail;
            if (Object.keys(pfrd) === 0) {
                return true;
            } else if (pfrd.patientFinancialResponsibility === "999999.99") {
                return true;
            }
        } else {
            return true;
        }
    if (bd.procedurePricingDetails) {
        const ppd = bd.procedurePricingDetails;
            if (ppd.length === 0) {
                return true;
            } else if (!ppd.some(beni => beni.procedureAllowedAmount !== '')) {
                return true;
            }
        } else {
            return true;
        }
    //} else {
    //    console.info(`estimateDetails displayErrorMessage surePayHealthDetail missing RETURN TRUE`, quote);
    //    return true;
    //}
    return false;
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EstimateDetails));
